import { render, staticRenderFns } from "./CollegeEvents.vue?vue&type=template&id=a084d428&scoped=true&"
import script from "./CollegeEvents.vue?vue&type=script&lang=js&"
export * from "./CollegeEvents.vue?vue&type=script&lang=js&"
import style0 from "./CollegeEvents.vue?vue&type=style&index=0&id=a084d428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a084d428",
  null
  
)

export default component.exports